// TypeScript型定義（フロントエンド）

export interface VeneerConfig {
  width: number;
  height: number;
  noRotation: boolean;
}

export interface CalculationInput {
  materialName: string;
  veneerConfigs: VeneerConfig[];
  pieceWidth: number;
  pieceHeight: number;
  kerf: number;
}

export interface CalculationResult {
  materialName: string;
  selectedVeneer: number;
  veneerWidth: number;
  veneerHeight: number;
  totalPieces: number;
  orientation: string;
  leftoverArea: number;
  horizontalCount: number;
  verticalCount: number;
  optimalPieceWidth: number;
  optimalPieceHeight: number;
}

export interface ApiResponse {
  result: CalculationResult;
  svg: string;
  svgDataUrl: string;
  inputData: CalculationInput;
}

export interface ApiError {
  error: string;
}

export interface FormData {
  materialName: string;
  veneerWidth1: string;
  veneerHeight1: string;
  veneerWidth2: string;
  veneerHeight2: string;
  pieceWidth: string;
  pieceHeight: string;
  kerf: string;
  allowRotation1: boolean;
  allowRotation2: boolean;
}

export interface ValidationErrors {
  [key: string]: string;
}

export interface CalculationHistory {
  id: string;
  timestamp: Date;
  input: FormData; // フォームデータを使用
  result: CalculationResult;
}

export const MATERIAL_OPTIONS = [
  '天地',
  '側板', 
  '背版',
  '扉',
  '棚板',
] as const;

export type MaterialType = typeof MATERIAL_OPTIONS[number];

export interface DefaultValues {
  veneerWidth1: number;
  veneerHeight1: number;
  veneerWidth2: number;
  veneerHeight2: number;
  kerf: number;
}

export const DEFAULT_VALUES: DefaultValues = {
  veneerWidth1: 900,
  veneerHeight1: 1800,
  veneerWidth2: 1200,
  veneerHeight2: 2400,
  kerf: 10,
};